import { Modal as ModalBootstrap } from 'react-bootstrap'
import '../../styles/Utils/Modal.css'

function Modal({ displayModal, setDisplayModal, button, header, body, footer, onShow, onHide, }) {

    return (

        <>

            <div className='modalButton'>
                {button}
            </div>
            <ModalBootstrap
                show={displayModal}
                size="lg"
                onShow={() => onShow ? onShow() : null}
                onHide={() => onHide ? (setDisplayModal(false), onHide()) : setDisplayModal(false)}>
                <ModalBootstrap.Header closeButton={true}>
                    <ModalBootstrap.Title>
                        {header}
                    </ModalBootstrap.Title>
                </ModalBootstrap.Header>
                <ModalBootstrap.Body>
                    {body}
                </ModalBootstrap.Body>
                <ModalBootstrap.Footer>
                    {footer}
                </ModalBootstrap.Footer>
            </ModalBootstrap>
        </>

    )

}

export default Modal